package br.com.texeratx.boardgametimeapp.ui.components.icon

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import boardgametimeapp.composeapp.generated.resources.Res
import boardgametimeapp.composeapp.generated.resources.img_games
import org.jetbrains.compose.resources.painterResource

@Composable
fun GamesIcon() {
    Image(
        painter = painterResource(Res.drawable.img_games),
        contentDescription = "Matches",
        modifier = Modifier.size(48.dp),
        contentScale = ContentScale.Fit
    )
}
